export type { AppNotification, NotificationStatus } from 'context/NotificationCenterContext';

export const NOTIFICATION_VARIANT = {
  STARTED:    'started',
  PROCESSING: 'processing',
  COMPLETED:  'completed',
  FAILED:     'failed',
} as const;

export type NotificationVariant = typeof NOTIFICATION_VARIANT[keyof typeof NOTIFICATION_VARIANT];
